module.exports = __webpack_public_path__ + "img/example.68bd9f77.svg";